import { __extends } from "tslib";
import ClosetObject from '../ClosetObject';
import { ltjsModule } from '../ltjsEnvironment';
import { getWrapper, getExistingWrapper } from '../WrappableCloset';
var DispatchBridge = /** @class */ (function (_super) {
    __extends(DispatchBridge, _super);
    function DispatchBridge(context, callback) {
        var _this = _super.call(this, arguments[0], arguments[1], arguments[2]) || this;
        _this._context = context;
        _this._callback = callback;
        return _this;
    }
    DispatchBridge.prototype.handleEvent = function (event) {
        if (this._callback) {
            this._callback.call(this._context, event);
        }
    };
    DispatchBridge.prototype._resetClosetAddress = function () {
        ltjsModule.runtime.dispatchBridgeMap.delete(ClosetObject.getAddress(this));
        _super.prototype._resetClosetAddress.call(this);
    };
    DispatchBridge._create = function () {
        //
        // Create the c++ DispatchBridge and return the closet key
        //
        var eventDispatcher = arguments[2];
        var eventDispatcher_jni = ClosetObject.getClosetAddress(eventDispatcher);
        // tslint:disable-next-line:no-unsafe-any
        var closetKey = ltjsModule.module._ltjs_commons_DispatchBridge_create(eventDispatcher_jni);
        ltjsModule.runtime.dispatchBridgeMap.set(closetKey, {
            getWrapper: getWrapper,
            getExistingWrapper: getExistingWrapper,
        });
        return closetKey;
    };
    return DispatchBridge;
}(ClosetObject));
export default DispatchBridge;
